module.exports = __webpack_public_path__ + "img/JT_icons01_64px_ChallengerYellow.89dd4b07.svg";